'use strict';

angular.module('amexReconciliationApp')
  .component('reallocateTransactionsButton', {
    templateUrl: 'scripts/views/components/reallocate-transactions-button.html',
    bindings: {},
    controller: function ($uibModal,
                          SelectedTransactionService,
                          SiteConfigModel,
                          TransactionSearchModel) {
      var self = this;

      function openReallocateTransactionsModal() {
        self.modalInstance = $uibModal.open({
          template: '<reallocate-transactions-modal close-modal-callback="$close"></reallocate-transactions-modal>'
        });
      }

      self.onClick = openReallocateTransactionsModal;

      self.showButton = function() {
        return !TransactionSearchModel.isLimitedRole();
      };

      self.isDisabled = function () {
        return SelectedTransactionService.selectedTransactionsCount() < 1 ||
          SelectedTransactionService.anyFullyLockedSelected() ||
          (SelectedTransactionService.anyPartiallyLockedSelected() &&
          SiteConfigModel.siteConfig().partialLockOptions.accountingLocked);
      };
    }
  });



//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/components/reallocateTransactionsButton.js
// module id = 470
// module chunks = 0